var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#113957"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#00df72",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#00c094",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#00df72",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#00c094",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#009ea3",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#007b9b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#009ea3",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_5",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#007b9b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#005980",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_6",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#113957",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#005980",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#00df72",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#87fa3c",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#00df72",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#00c094",
    stopOpacity: 1
  })))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#009ea3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#00c094",
    stopOpacity: 1
  })))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#009ea3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#007b9b",
    stopOpacity: 1
  })))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_5",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#005980",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#007b9b",
    stopOpacity: 1
  })))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_6",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#005980",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#113957",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-513.8 0C-486.7 -20.9 -459.7 -41.8 -453.3 -65.2C-447 -88.6 -461.3 -114.4 -454.8 -133.5C-448.3 -152.7 -420.9 -165.2 -416.6 -190.3C-412.3 -215.4 -431.1 -253.1 -417.3 -268.2C-403.4 -283.3 -356.9 -275.8 -343.1 -297.3C-329.3 -318.9 -348.3 -369.5 -336.5 -388.3C-324.7 -407.1 -282.1 -394.1 -251.4 -391.2C-220.7 -388.3 -201.9 -395.4 -182 -398.4C-162 -401.5 -141.1 -400.4 -123.7 -421.2C-106.3 -442 -92.5 -484.7 -72.4 -503.8C-52.4 -522.9 -26.2 -518.3 0 -513.8L0 0Z",
    fill: "#00486c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-440.4 0C-417.2 -17.9 -394 -35.8 -388.6 -55.9C-383.1 -75.9 -395.4 -98 -389.8 -114.5C-384.2 -130.9 -360.8 -141.6 -357.1 -163.1C-353.4 -184.6 -369.5 -216.9 -357.7 -229.8C-345.8 -242.8 -305.9 -236.4 -294.1 -254.8C-282.3 -273.3 -298.5 -316.7 -288.4 -332.8C-278.3 -349 -241.8 -337.8 -215.5 -335.3C-189.2 -332.8 -173 -338.9 -156 -341.5C-138.9 -344.1 -120.9 -343.2 -106 -361C-91.1 -378.9 -79.2 -415.5 -62.1 -431.8C-44.9 -448.2 -22.5 -444.3 0 -440.4L0 0Z",
    fill: "#006a90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-367 0C-347.7 -14.9 -328.4 -29.9 -323.8 -46.6C-319.3 -63.3 -329.5 -81.7 -324.9 -95.4C-320.2 -109.1 -300.6 -118 -297.6 -135.9C-294.5 -153.8 -307.9 -180.8 -298 -191.5C-288.1 -202.3 -254.9 -197 -245.1 -212.4C-235.2 -227.8 -248.8 -263.9 -240.3 -277.4C-231.9 -290.8 -201.5 -281.5 -179.6 -279.4C-157.6 -277.3 -144.2 -282.4 -130 -284.6C-115.7 -286.8 -100.8 -286 -88.3 -300.9C-75.9 -315.7 -66 -346.2 -51.7 -359.9C-37.4 -373.5 -18.7 -370.2 0 -367L0 0Z",
    fill: "#008da2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293.6 0C-278.1 -11.9 -262.7 -23.9 -259.1 -37.2C-255.4 -50.6 -263.6 -65.4 -259.9 -76.3C-256.2 -87.3 -240.5 -94.4 -238.1 -108.7C-235.6 -123.1 -246.4 -144.6 -238.4 -153.2C-230.5 -161.9 -203.9 -157.6 -196.1 -169.9C-188.2 -182.2 -199 -211.1 -192.3 -221.9C-185.5 -232.6 -161.2 -225.2 -143.7 -223.5C-126.1 -221.9 -115.3 -225.9 -104 -227.7C-92.6 -229.4 -80.6 -228.8 -70.7 -240.7C-60.7 -252.6 -52.8 -277 -41.4 -287.9C-30 -298.8 -15 -296.2 0 -293.6L0 0Z",
    fill: "#00af9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-220.2 0C-208.6 -9 -197 -17.9 -194.3 -27.9C-191.6 -38 -197.7 -49 -194.9 -57.2C-192.1 -65.4 -180.4 -70.8 -178.5 -81.5C-176.7 -92.3 -184.8 -108.5 -178.8 -114.9C-172.9 -121.4 -153 -118.2 -147 -127.4C-141.1 -136.7 -149.3 -158.4 -144.2 -166.4C-139.1 -174.5 -120.9 -168.9 -107.7 -167.6C-94.6 -166.4 -86.5 -169.4 -78 -170.8C-69.4 -172.1 -60.5 -171.6 -53 -180.5C-45.5 -189.4 -39.6 -207.7 -31 -215.9C-22.5 -224.1 -11.2 -222.1 0 -220.2L0 0Z",
    fill: "#00d086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-146.8 0C-139.1 -6 -131.3 -11.9 -129.5 -18.6C-127.7 -25.3 -131.8 -32.7 -129.9 -38.2C-128.1 -43.6 -120.3 -47.2 -119 -54.4C-117.8 -61.5 -123.2 -72.3 -119.2 -76.6C-115.3 -80.9 -102 -78.8 -98 -84.9C-94.1 -91.1 -99.5 -105.6 -96.1 -110.9C-92.8 -116.3 -80.6 -112.6 -71.8 -111.8C-63.1 -110.9 -57.7 -113 -52 -113.8C-46.3 -114.7 -40.3 -114.4 -35.3 -120.3C-30.4 -126.3 -26.4 -138.5 -20.7 -143.9C-15 -149.4 -7.5 -148.1 0 -146.8L0 0Z",
    fill: "#45ed5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.4 0C-69.5 -3 -65.7 -6 -64.8 -9.3C-63.9 -12.7 -65.9 -16.3 -65 -19.1C-64 -21.8 -60.1 -23.6 -59.5 -27.2C-58.9 -30.8 -61.6 -36.2 -59.6 -38.3C-57.6 -40.5 -51 -39.4 -49 -42.5C-47 -45.6 -49.8 -52.8 -48.1 -55.5C-46.4 -58.2 -40.3 -56.3 -35.9 -55.9C-31.5 -55.5 -28.8 -56.5 -26 -56.9C-23.1 -57.4 -20.2 -57.2 -17.7 -60.2C-15.2 -63.1 -13.2 -69.2 -10.3 -72C-7.5 -74.7 -3.7 -74 0 -73.4L0 0Z",
    fill: "#87fa3c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.8 0C491.6 21.7 469.4 43.4 461.3 66.3C453.1 89.2 458.9 113.3 451 132.4C443 151.5 421.3 165.6 421.2 192.3C421 219.1 442.5 258.4 432.2 277.8C422 297.1 379.9 296.4 356.7 309.1C333.5 321.8 329.1 347.8 311.1 359C293 370.2 261.2 366.6 237.3 369.3C213.5 372 197.4 381.1 182.4 399.3C167.3 417.6 153.2 445 134.1 456.7C115 468.4 90.9 464.3 67.7 471.2C44.6 478 22.3 495.9 0 513.8L0 0Z",
    fill: "#00486c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.4 0C421.4 18.6 402.4 37.2 395.4 56.8C388.4 76.5 393.4 97.1 386.5 113.5C379.7 129.9 361.1 141.9 361 164.9C360.9 187.8 379.3 221.5 370.5 238.1C361.7 254.7 325.6 254.1 305.8 264.9C285.9 275.8 282.1 298.1 266.6 307.7C251.1 317.3 223.9 314.2 203.4 316.6C183 318.9 169.2 326.6 156.3 342.3C143.4 357.9 131.3 381.5 114.9 391.5C98.6 401.5 77.9 397.9 58.1 403.8C38.2 409.7 19.1 425.1 0 440.4L0 0Z",
    fill: "#006a90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 0C351.2 15.5 335.3 31 329.5 47.4C323.6 63.7 327.8 80.9 322.1 94.6C316.4 108.2 300.9 118.3 300.8 137.4C300.7 156.5 316.1 184.6 308.7 198.4C301.4 212.2 271.4 211.7 254.8 220.8C238.2 229.8 235.1 248.4 222.2 256.4C209.3 264.4 186.6 261.8 169.5 263.8C152.5 265.7 141 272.2 130.3 285.2C119.5 298.3 109.4 317.9 95.8 326.2C82.1 334.6 64.9 331.6 48.4 336.5C31.8 341.5 15.9 354.2 0 367L0 0Z",
    fill: "#008da2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6 0C280.9 12.4 268.2 24.8 263.6 37.9C258.9 51 262.2 64.8 257.7 75.7C253.2 86.6 240.7 94.6 240.7 109.9C240.6 125.2 252.9 147.7 247 158.7C241.1 169.8 217.1 169.4 203.8 176.6C190.6 183.9 188.1 198.7 177.7 205.1C167.4 211.5 149.3 209.5 135.6 211C122 212.6 112.8 217.8 104.2 228.2C95.6 238.6 87.5 254.3 76.6 261C65.7 267.7 52 265.3 38.7 269.2C25.5 273.2 12.7 283.4 0 293.6L0 0Z",
    fill: "#00af9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2 0C210.7 9.3 201.2 18.6 197.7 28.4C194.2 38.2 196.7 48.6 193.3 56.7C189.9 64.9 180.6 71 180.5 82.4C180.4 93.9 189.6 110.8 185.2 119C180.8 127.3 162.8 127 152.9 132.5C142.9 137.9 141.1 149 133.3 153.8C125.6 158.7 112 157.1 101.7 158.3C91.5 159.4 84.6 163.3 78.2 171.1C71.7 179 65.7 190.7 57.5 195.7C49.3 200.7 39 199 29 201.9C19.1 204.9 9.5 212.5 0 220.2L0 0Z",
    fill: "#00d086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8 0C140.5 6.2 134.1 12.4 131.8 18.9C129.5 25.5 131.1 32.4 128.8 37.8C126.6 43.3 120.4 47.3 120.3 55C120.3 62.6 126.4 73.8 123.5 79.4C120.6 84.9 108.5 84.7 101.9 88.3C95.3 91.9 94 99.4 88.9 102.6C83.7 105.8 74.6 104.7 67.8 105.5C61 106.3 56.4 108.9 52.1 114.1C47.8 119.3 43.8 127.2 38.3 130.5C32.9 133.8 26 132.6 19.4 134.6C12.7 136.6 6.4 141.7 0 146.8L0 0Z",
    fill: "#45ed5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4 0C70.2 3.1 67.1 6.2 65.9 9.5C64.7 12.7 65.6 16.2 64.4 18.9C63.3 21.6 60.2 23.7 60.2 27.5C60.1 31.3 63.2 36.9 61.7 39.7C60.3 42.4 54.3 42.3 51 44.2C47.6 46 47 49.7 44.4 51.3C41.9 52.9 37.3 52.4 33.9 52.8C30.5 53.1 28.2 54.4 26.1 57C23.9 59.7 21.9 63.6 19.2 65.2C16.4 66.9 13 66.3 9.7 67.3C6.4 68.3 3.2 70.8 0 73.4L0 0Z",
    fill: "#87fa3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob2.21260c956d71b21c67eda90d0e0685ae.svg";
export { ForwardRef as ReactComponent };